import React, { useEffect, useState } from "react";
import Layout from "../Layout";
import List from "../Components/Coupon/List";
import Add from "../Components/Coupon/Add";
import { useLocation } from "react-router-dom";
import ScanView from "../Components/Artisan/ScanView";
import View from "../Components/Artisan/View";

function Coupon() {
  const [comp, setComp] = useState("list");
  const [rowData, setRowData] = useState();
  const location = useLocation();

  useEffect(() => {
    setComp("list");
  }, [location]);
  function handleChange(newValue) {
    setComp(newValue.mode);
    setRowData(newValue.rowData);
  }
  return (
    <Layout>
      <div className="main-content">
        <section className="section">
          <div className="section-header">
            <h1>Coupon</h1>
          </div>

          {comp === "list" ? (
            <List comp={comp} onChange={handleChange} rowData={rowData} />
          ) : comp === "view" ? (
            <View comp={comp} rowData={rowData} onChange={handleChange} />
          ) : comp === "scan" ? (
            <ScanView comp={comp} rowData={rowData} onChange={handleChange} />
          ) : (
            <Add comp={comp} rowData={rowData} onChange={handleChange} />
          )}
        </section>
      </div>
    </Layout>
  );
}

export default Coupon;
